import {sendPostRequest} from '../../node-apiRequest.js'

export const doLogin = async (email : string, password : string) => {

    const response = await sendPostRequest("/api/login", {
        email,
        password
    })

    return {
        success: response.statusCode === 200,
        message: response.body.message
    }
}
